module.exports = __webpack_public_path__ + "img/logo.93551975.png";